
























import moment from 'moment';
import { Vue, Component, PropSync, Watch, Prop } from 'vue-property-decorator';

@Component
export default class RuleFormTab4 extends Vue {
  @PropSync('formData') syncFormData!: any;

  time = moment('00:00:00', 'HH:mm:ss');
  date = moment().format('YYYY-MM-DD');
  type = 0;

  created() {
    this.onSyncSubSyncDefsChange();
  }

  @Watch('syncFormData')
  onSyncSubSyncDefsChange() {
    this.date = this.syncFormData.jobConfig.runDateFormat || moment().format('YYYY-MM-DD');
    this.time = this.syncFormData.jobConfig.runDateStr || moment('00:00:00', 'HH:mm:ss');
    this.type = this.syncFormData.jobConfig.rate;
  }

  changeCron() {
    let month = moment(this.date).format('M');
    let day = moment(this.date).format('D');
    let hour = moment(this.time).hour();
    let minute = moment(this.time).minute();
    let second = moment(this.time).second();
    let cron = '';
    if (this.syncFormData.jobMode == 1) {
      cron = `${second} ${minute} ${hour} ${day} ${month} ?`;
    }
    if (this.syncFormData.jobMode == 2) {
      this.type == 0 && (cron = `${second} ${minute} ${hour} * * ?`);
      this.type == 1 && (cron = `${second} ${minute} * * * ?`);
    }
    this.syncFormData.cronExpression = cron;
    this.syncFormData.jobConfig = {
      rate: this.type,
      runDateFormat: moment(this.date).format(),
      runDateStr: moment(this.time).format()
    };
  }
}
